import { z } from 'zod';

export const SharedTabletAppRoleSchema = z.enum([
  'consulente',
  'ristoratore',
  'osa',
  'staff',
]);

export const SharedTabletOperatorSchema = z.object({
  tenant_personnel_id: z.string().uuid(),
  full_name: z.string().trim().min(1).max(200),
  role: z.string().trim().min(1).max(100),
  pin_enabled: z.boolean(),
  pin_version: z.number().int().nonnegative(),
  identity_fingerprint: z.string().regex(/^[0-9a-f]{64}$/).nullable(),
});
export type SharedTabletOperator = z.infer<typeof SharedTabletOperatorSchema>;

export const SharedTabletOperatorsSchema = z.array(SharedTabletOperatorSchema).max(1_000);

export const SharedTabletUnlockOkSchema = z.object({
  status: z.literal('ok'),
  grant_id: z.string().uuid(),
  grant_token: z.string().regex(/^[0-9a-f]{64}$/),
  grant_expires_at: z.string().datetime({ offset: true }),
  tenant_personnel_id: z.string().uuid(),
  full_name: z.string().trim().min(1).max(200),
  role: z.string().trim().min(1).max(100),
  app_role: SharedTabletAppRoleSchema,
  account_user_id: z.string().uuid().nullable(),
  pin_version: z.number().int().positive(),
  identity_fingerprint: z.string().regex(/^[0-9a-f]{64}$/),
});
export type SharedTabletUnlockSuccess = z.infer<typeof SharedTabletUnlockOkSchema>;

export const SharedTabletOperatorAuthorizationSchema = z.object({
  tenant_personnel_id: z.string().uuid(),
  app_role: SharedTabletAppRoleSchema,
  account_user_id: z.string().uuid().nullable(),
});
